module.exports = __webpack_public_path__ + "static/media/wind-turbine_inactive.c04e156d.svg";